import { useCallback } from "react";
import useHasErrors from "../useHasErrors.js";
export const useHandleSubmit = ()=>{
    const hasErrors = useHasErrors();
    const handleSubmit = useCallback((e)=>{
        if (hasErrors) e.preventDefault();
    }, [
        hasErrors
    ]);
    return handleSubmit;
};
export default useHandleSubmit;

//# sourceMappingURL=useHandleSubmit.js.map